<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="$router.push('/')"/>
    <div class="logout"></div>
    <PanelLoader v-if="loadingMood"/>
</template>

<script>
    import Alert from "../../components/Alert"
    import axios from "axios"
    import PanelLoader from "../../components/PanelLoader"
    export default {
        name: "Logout",
        components:{
            Alert,
            PanelLoader
        },
        data(){
            return{
                alertContent: null,
                loadingMood: false,
            }
        },
        methods:{
            async handleLogOut(){
                try {
                    this.loadingMood=true;
                    await axios.get('/api/authentication/logout',{headers:{"Authorization" : `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood=false;
                    localStorage.removeItem('token');
                    localStorage.removeItem('email');
                    localStorage.removeItem('unique_id');
                    localStorage.setItem('loginStatus','false');
                    this.$store.state.loginStatus = false;
                    this.alertContent={
                        message: 'شما با موفقیت خارج شدید!',
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        href:'https://canada-az-iran.com',
                        buttonType:'link',//link//confirm
                        buttonText:'تایید',
                        buttonLink:'/',///personal-info
                        closeButtonShow:false,
                        waitingMode:false
                    };
                } catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',//close
                        buttonText:'تایید',
                        buttonLink:'',///personal-info
                        closeButtonShow:true,
                        waitingMode:false
                    };
                }
            },
        },
        mounted(){
            this.handleLogOut();
        }
    }
</script>

<style scoped>
.logout{
    height: 566px;
    text-align: center;
}
</style>